import React from 'react'
import Loading from '../components/Loading'
import RouteCard from '../components/RouteCard'
import Carousel from '../components/Carousel'
import { useViewport  } from '../slices/ui'
import { useGuide } from "../api"

import settings from '../conf'
import {
  GO_TO_HOME_PAGE
} from "../trans"


const RoutesView = (props) => {
  const guide = useGuide()
  if (!guide) return <Loading/>

  const cards = guide.routes.map((route) => <RouteCard {...route} />)

  return (
    <div className="pwa__routes__container">
      <h1 className="pwa__routes__title"><a href={settings.HOME_URL}>{guide.title}</a></h1>
      <Carousel items={cards} className="pwa__routes__carousel" />
      <a href={settings.HOME_URL} className="button secondary pwa__footer_button">{GO_TO_HOME_PAGE}</a>
    </div>
  )
  
}

export default RoutesView
